// Collar + esclava a juego que también se venden como Conjunto (precio de paquete, en
// /conjuntos). Al marcar "+ a juego" en la ficha se agrega el Conjunto en vez de las dos
// piezas sueltas, para que el cliente no pague más por armarlo él mismo.
// El juego Gucci (tejido-torzal-gucci + esclava-tejido-gucci → conjunto-torzal-gucci) queda
// fuera a propósito: ese conjunto cuesta $799 desde que el collar valía $550 y su precio
// está pendiente de confirmar con el dueño (AUDITORIA-QUINLATE-2026-10-16.md, P1-05).
const BUNDLES = [
  { pieces: ['torzal', 'esclava-tejido-torzal'], bundle: 'conjunto-torzal' },
  { pieces: ['torzal-cartier', 'esclava-tejido-cartier'], bundle: 'conjunto-cartier' },
  { pieces: ['tejido-torzal-barbado', 'esclava-tejido-barbado'], bundle: 'conjunto-torzal-barbado' },
];

// Id del Conjunto que equivale a estas dos piezas (en cualquier orden), o null.
export function findBundleId(pieceA, pieceB) {
  const match = BUNDLES.find(
    ({ pieces }) => pieceA !== pieceB && pieces.includes(pieceA) && pieces.includes(pieceB)
  );
  return match ? match.bundle : null;
}
